import { Pipe, PipeTransform } from '@angular/core';
import { map, Observable } from 'rxjs';
import { CheckboxesService } from '../services/checkboxes.service';

@Pipe({
    name: 'checkboxStatus',
    standalone: true
})
export class CheckboxStatusPipe implements PipeTransform {

	constructor(private checkboxesService: CheckboxesService) {}

	transform(key: number): Observable<boolean> {
		return this.checkboxesService.changeDetection
			.asObservable()
			.pipe(map(() =>
				(this.checkboxesService.isSelectedAll && !this.checkboxesService.excluded.isSelected(key)) ||
				this.checkboxesService.selection.isSelected(key)
			));
	}
}
